import moment from 'moment';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as Green } from '../assets/oval_green.svg';
import { ReactComponent as Red } from '../assets/oval_red.svg';
import CustomButton from './Common/Button/Button';
import { capitalize, isOrderStatusActive, isRoleTitan, ORDER } from './utils';

const OrderListItem = ({
  order,
  orderType,
  onViewClicked,
  index,
  accessToMultiplePartners,
  userRole,
}) => {
  const [isOrderDetailsLoading, setIsOrderDetailsLoading] = useState(false);

  const _onViewClicked = async (index) => {
    setIsOrderDetailsLoading(true);
    await onViewClicked(index);
    setIsOrderDetailsLoading(false);
  };

  const renderStatusIndicator = (status) => {
    const normalizedStatus = status.toLowerCase();
    const Icon = isOrderStatusActive(normalizedStatus) ? Green : Red;
    return (
      <div>
        <Icon className="state-logo" /> {capitalize(status)}
      </div>
    );
  };

  const source =
    orderType === ORDER.DOMAIN
      ? order.source && <span>{order.source}</span>
      : orderType === ORDER.CUSTOMER && (
          <span className="order-column-domain">{order.domainName}</span>
        );

  // Only display customerId if it's defined
  const customerId = order.customer?.customerId
    ? `${order.customer.customerId}`
    : '';
  const sourceValue = (
    <div>
      {source} {source && customerId && ': '}
      {customerId}
    </div>
  );

  const status = renderStatusIndicator(order.status);
  const creationDate = moment(order.createdAt).format('Do MMM YYYY');

  return (
    <tr className={'order-list-row'}>
      {(isRoleTitan(userRole) || accessToMultiplePartners) && (
        <td className="order-column-partner">{order.partner?.name}</td>
      )}
      <td className="order-column-source">{sourceValue}</td>
      <td className="order-column-creation-date">{creationDate}</td>
      <td className="order-column-status">{status}</td>
      <td>
        <CustomButton
          onClick={() => _onViewClicked(index)}
          className={'orders-table-button'}
          type={'secondary'}
          isLoading={isOrderDetailsLoading}
          disabled={isOrderDetailsLoading}
        >
          <FormattedMessage id="order-list-button-text" />
        </CustomButton>
      </td>
    </tr>
  );
};

export default OrderListItem;
